/* eslint-disable react/no-danger  */
import React from 'react';

const ProviderDescription = (props) => {
    const { network } = props;

    const getCommonDescription = () => (
        <div>
            <p>Allstate Benefits is a marketing name for: Integon National Insurance Company in TX and IN; and National Health Insurance Company in MO, FL and WI. Group health insurance plans offered by Allstate Benefits are offered by Integon National Insurance Company in TX and IN; and National Health Insurance Company in MO, FL, and WI.</p>
            <p>
            This online directory is updated weekly, but it is for reference only. We make every effort to ensure current, accurate data, but changes occur daily and may not be reflected immediately.  If you feel you have identified a discrepancy, please contact us at
                <a href="mailto:ABGHProviderDirectory@allstate.com"> ABGHProviderDirectory@allstate.com</a>
            .
            </p>
        </div>
    );

    const getProviderDescription = (ntwrkName) => {
        return (
            <>
                <div dangerouslySetInnerHTML={{ __html: ntwrkName.htmlBlurb }} />
                {getCommonDescription()}
            </>
        );
    };

    return (
        <div className="provider-desc">
            {
                network[0].htmlBlurb !== null
                ? getProviderDescription(network[0])
                : getCommonDescription()
            }
        </div>
    );
};

export default ProviderDescription;
